"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Label = _interopRequireDefault(require("./Label.style"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var Label = function Label(_ref) {
  var id = _ref.id,
    children = _ref.children,
    className = _ref.className,
    htmlFor = _ref.htmlFor,
    required = _ref.required,
    isDisabled = _ref.isDisabled;
  return /*#__PURE__*/_react["default"].createElement(_Label["default"], {
    id: id,
    className: className,
    isDisabled: isDisabled,
    htmlFor: htmlFor,
    required: required
  }, children, required ? ' *' : '');
};
Label.propTypes = {
  id: _propTypes["default"].string,
  /**
   * The contents of the `Label`.
   */
  children: _propTypes["default"].node,
  /**
   * @ignore
   */
  className: _propTypes["default"].string,
  /**
   * @ignore
   */
  htmlFor: _propTypes["default"].string,
  /**
   * if `true`, the label will indicate that the input is required.
   */
  required: _propTypes["default"].bool,
  /**
   * if disabled we will gray it out
   */
  isDisabled: _propTypes["default"].bool
};
Label.defaultProps = {
  id: '',
  className: '',
  htmlFor: '',
  required: false,
  isDisabled: false,
  children: null
};
Label.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Label",
  "props": {
    "id": {
      "defaultValue": {
        "value": "''",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "className": {
      "defaultValue": {
        "value": "''",
        "computed": false
      },
      "description": "@ignore",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "htmlFor": {
      "defaultValue": {
        "value": "''",
        "computed": false
      },
      "description": "@ignore",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "required": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "if `true`, the label will indicate that the input is required.",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "isDisabled": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "if disabled we will gray it out",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "children": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "description": "The contents of the `Label`.",
      "type": {
        "name": "node"
      },
      "required": false
    }
  }
};
var _default = /*#__PURE__*/(0, _react.memo)(Label);
exports["default"] = _default;